import { render, staticRenderFns } from "./CancelamentoEmMassaV2.vue?vue&type=template&id=32cfa70f"
import script from "./CancelamentoEmMassaV2.vue?vue&type=script&lang=js"
export * from "./CancelamentoEmMassaV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports